module.exports = __webpack_public_path__ + "img/mobileapps.7f7f8847.svg";